/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { Button, CustomHeader, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import {
  Animated,
  Dimensions,
  Image,
  Platform,
  ScrollView,
  StatusBar,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import flash from "config/flash"
import { colors } from "colors"
import moment from "moment-timezone"
import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons"
import LinearGradient from "react-native-linear-gradient"
import Modal from "react-native-modal"
import RenderHTML from "react-native-render-html"

// import coffeeIcon from "../../../../assets/coffee-icon.png"

import coffeeIcon from "../../../../assets/star-icon.png"
import { useColor } from "app/theme/getThemes"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { random, size } from "lodash"
import { typography } from "theme"
import claimedImg from "../../../../assets/claimed-img.png"

export const StampsDetailScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()
  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()

  const route = useRoute()
  const { routeFrom, item }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [data] = useState(item)

  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [isTncOpen, setIsTncOpen] = useState(false)

  console.log("data === >", data)

  const [maxHeight] = useState(60)
  const [minHeight] = useState(Platform.OS === "web" ? 50 : 55)
  const [scrollY] = useState(new Animated.Value(0))

  const headerHeight = scrollY.interpolate({
    inputRange: [0, maxHeight - minHeight],
    outputRange: [maxHeight, minHeight],
    extrapolate: "clamp",
  })

  const [isMinimized, setIsMinimized] = useState(false)

  const handleScroll = Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], {
    useNativeDriver: false,
    listener: (event) => {
      const scrollOffset = event.nativeEvent.contentOffset.y
      setIsMinimized(scrollOffset > (maxHeight - minHeight) / 2)
    },
  })

  const Accordion = ({ type, text }: { type: "redeem" | "tnc"; text: string }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen

    const regex = /<[^>]*>/gim
    const filteredText = text?.replace(regex, "")

    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>
            {type === "redeem"
              ? translate("voucherDetailScreen.howToUse")
              : translate("promotionDetailScreen.tnc")}
          </Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={companyTheme.first} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={companyTheme.first} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <View>
            <View style={style.accordionContentContainer} />
            <Text>{filteredText}</Text>
          </View>
        )}
      </View>
    )
  }

  const [isVoucherExpired, setIsVoucherExpired] = useState(
    item?.use_at
      ? moment().tz("Asia_Kuala_Lumpur").isAfter(moment(item?.use_at)?.add("m", 15))
      : false,
  )

  const isExpired = moment().isAfter(moment(item?.end_date))

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

  const [stampCount, setStampCount] = useState<any>([])

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const redeemVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/stamps/member`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        stamp_catalog_id: data?.stamp_catalog_id,
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          onCloseModal()
          navigation.goBack()
          flash("success", translate("voucherDetailScreen.redeemSuccesfully"))
        } else {
          onCloseModal()

          const errorMsg = await res?.json()

          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (
            errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
          ) {
            flash("error", translate("errors.notEnoughPoint"))
          } else {
            flash("error", translate("errors.failedToRedeemNoVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRedeemNoVoucher"))
        console.error(e)
      })
  }

  const getStampsDetails = async () => {
    await fetch(
      `${process.env.API_URL}/api/stamp_list/member/${userStore?.id}/${data?.stamp_catalog_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      },
    )
      .then(async (res) => {
        if (res?.ok) {
          const data = await res.json()

          const sortedData = data.sort((a, b) => b.stamp_id - a.stamp_id)
          console.log("res", sortedData)

          setStampCount(sortedData)
        } else {
          flash("error", translate("errors.failedToRedeemNoVoucher"))
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRedeemNoVoucher"))
        console.error(e)
      })
  }

  useEffect(() => {
    getStampsDetails()
  }, [])

  const redeemableStamp = Object.values(
    stampCount
      .filter((stamp) => stamp.updated_status === "redeemable" && stamp.status !== "redeemed")
      .reduce((acc, stamp) => {
        acc[stamp.stamp_id] = stamp // Keep only the latest occurrence per stamp_id
        return acc
      }, {} as Record<number, (typeof stampCount)[number]>),
  )

  console.log("stampCount", stampCount)
  const ProgressBar = ({ stampCount, currentProgress, expired }) => {
    console.log(stampCount, currentProgress, expired, "----")
    const redeemed = expired === "redeemed"

    return (
      <>
        <View
          style={{
            display: "flex",
            backgroundColor: colors.lighterGrey,
            marginTop: 10,
            opacity: redeemed ? 0.5 : 1,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              paddingHorizontal: 10,
              marginVertical: 10,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
            }}
          >
            <View style={style.starbox}>
              <View>
                {(() => {
                  const totalStamps = data?.stamp_required || 0

                  console.log("totalStamps", totalStamps)

                  // Generate index array or fallback to a single null for placeholder
                  const stampIndices =
                    totalStamps >= 0 ? Array.from({ length: totalStamps }, (_, i) => i) : [1] // ensure one placeholder row

                  // Chunk into rows of 5
                  const rows = stampIndices.reduce((acc: any[][], item, idx) => {
                    if (idx % 5 === 0) acc.push([])
                    acc[acc.length - 1].push(item)
                    return acc
                  }, [])

                  const imageSource =
                    Platform.OS === "web"
                      ? data?.stamp_progress_image || coffeeIcon
                      : data?.stamp_progress_image
                      ? { uri: data.stamp_progress_image }
                      : coffeeIcon

                  return rows.map((row, rowIndex) => (
                    <View
                      key={rowIndex}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-around",
                        marginVertical: 5,
                        marginHorizontal: 10,
                        width: "100%",
                      }}
                    >
                      {row.map((idx, colIndex) => (
                        <View
                          key={idx ?? `placeholder-${colIndex}`}
                          style={{
                            backgroundColor:
                              typeof idx === "number" && idx < Number(stampCount)
                                ? companyTheme.first
                                : colors.lightGrey,
                            width: 50,
                            height: 50,
                            marginRight: 10,
                            borderRadius: 5,
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                          }}
                        >
                          <View
                            style={{
                              width: "80%",
                              height: "80%",
                              borderRadius: 5,
                              overflow: "hidden",
                              backgroundColor: "transparent", // Optional: Helps with rendering on some Android devices
                            }}
                          >
                            <Image
                              source={imageSource}
                              style={{
                                width: "100%",
                                height: "100%",
                                resizeMode: "contain",
                              }}
                            />
                          </View>
                        </View>
                      ))}
                    </View>
                  ))
                })()}
              </View>
            </View>
            <Text
              style={[style.tierSpendText, { textAlign: "right", width: "100%", fontSize: 13 }]}
            >
              You have collected ({currentProgress}/{data?.stamp_required}) stamps
            </Text>
          </View>
        </View>
        {/* {redeemed && (
          <View>
            <Image
              source={{ uri: claimedImg }}
              resizeMode="cover"
              style={{
                width: 80,
                height: 80,
                position: "absolute",
                right: 10,
                bottom: 20,
                zIndex: 999,
              }}
            />
          </View>
        )} */}
      </>
    )
  }
  return (
    <>
      <CustomHeader headerTitle={data?.stamp_name || ""} />

      <Screen>
        <View style={style.container}>
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={style.flex}
            scrollEventThrottle={16}
            onScroll={handleScroll}
          >
            <View style={style.flex}>
              <View
                style={{
                  height: height * 0.3,
                  width: "100%",
                  backgroundColor: companyTheme.second,
                }}
              >
                <Image
                  source={{
                    uri: data?.stamp_image,
                  }}
                  resizeMode="contain"
                  style={[style.image, { height: height * 0.3, resizeMode: "contain" }]}
                />
              </View>

              <View style={{ paddingHorizontal: 10 }}>
                <Text style={style.title}>{data?.stamp_name}</Text>

                <View style={{ marginTop: 5 }}>
                  <RenderHTML
                    defaultTextProps={{
                      style: {
                        fontFamily: typography.primary.normal, // Corrected from fontsFamily to fontFamily
                        marginTop: 10,
                      },
                    }}
                    source={{
                      html: data?.stamp_description,
                    }}
                  />
                </View>
              </View>
              <View style={[style.calendarContainer, { padding: 10 }]}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />
                <Text style={style.dateText}>
                  {moment(item?.start_date).format("DD-MMM-YYYY")} -{" "}
                  {moment(item?.end_date).format("DD-MMM-YYYY")}
                </Text>
              </View>
              {stampCount?.length > 0 ? (
                stampCount.map((item, index) => (
                  <ProgressBar
                    key={item.stamp_id || index}
                    stampCount={item?.stamp_count}
                    currentProgress={item?.stamp_count}
                    expired={item?.status}
                  />
                ))
              ) : (
                <ProgressBar key="default" stampCount={0} currentProgress={0} expired={false} />
              )}

              <View style={{ paddingHorizontal: 10 }}>
                <Accordion type="redeem" text={item?.stamp_how_to_redeem} />
                <Accordion type="tnc" text={item?.stamp_tnc} />
              </View>
            </View>
          </ScrollView>
        </View>
        <View
          style={[
            style.stickyBottomContainer,
            routeFrom === "voucherHistory"
              ? !isVoucherExpired
                ? {}
                : {
                    backgroundColor: colors.background,
                  }
              : {},
          ]}
        >
          <>
            {isExpired ? (
              <Text style={style.usedExpiredText}>
                {translate("voucherDetailScreen.expiredOnstamp")}{" "}
                {moment(item?.end_date).format("DD-MM-YYYY • hh:mm")}
              </Text>
            ) : (
              <>
                {routeFrom !== "redeemVoucher" && (
                  <Text style={style.dontClickText}>
                    {translate("voucherDetailScreen.dontClickVoucher")}
                  </Text>
                )}
                <Button
                  onPress={() => {
                    if (item?.expired) {
                      flash("error", translate("errors.failedToRedeem"))
                    } else if (!redeemableStamp) {
                      flash("error", "Not enough stamp to redeem")
                    } else if (redeemableStamp.length === 0) {
                      flash("error", "Not enough stamp to redeem")
                    } else {
                      setIsModalVisible(true)
                    }
                  }}
                  title={
                    routeFrom === "redeemVoucher"
                      ? translate("voucherDetailScreen.redeem")
                      : "Redeem Now"
                  }
                  // disabled={Number(data?.total_stamp_count) < Number(data?.stamp_required)}
                  style={[
                    style.buttonContainer,
                    {
                      backgroundColor: `${
                        Number(data?.total_stamp_count) < Number(data?.stamp_required)
                          ? colors.lightGrey
                          : colors.buttonBackground
                      }`,
                    },
                  ]}
                  titleStyle={style.buttonText}
                />
              </>
            )}
          </>
        </View>

        <Modal
          isVisible={isModalVisible}
          onBackdropPress={() => {
            onCloseModal()
          }}
          onBackButtonPress={() => {
            onCloseModal()
          }}
        >
          <View style={style.modalContainer}>
            <>
              <Text>{translate("voucherDetailScreen.areYouSureRedeem")}</Text>
              <View style={style.redeemModalContainer}>
                <Button
                  onPress={() => onCloseModal()}
                  title={translate("voucherDetailScreen.redeemLater")}
                  style={[
                    style.redeemLaterButton,
                    { borderColor: companyTheme.first, backgroundColor: "white" },
                  ]}
                  titleStyle={{
                    color: companyTheme.first,
                  }}
                />
                <Button
                  onPress={() => {
                    redeemVoucher()
                  }}
                  title={translate("voucherDetailScreen.redeem")}
                  style={{ flex: 1 }}
                />
              </View>
            </>
          </View>
        </Modal>
      </Screen>
    </>
  )
}
